// UnauthorizedPage.js
import React from 'react';

const UnauthorizedPage = () => {
    return (
        <div>
            <h2>Unauthorized</h2>
            <p>You do not have access to this page.</p>
        </div>
    );
};

export default UnauthorizedPage;
